<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  *{
    margin:0;
    padding:0;
  }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height:100%
}
  html,
  body {
    height: 100%;
    background-color: #F2F7FA;
  }
  .main-bg{
    background: #fff;
    min-height: calc(100% - 40px);
     padding:20px;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue